import React from 'react';

import { Box, Typography } from '@lyearn/ui';

import { TooltipTitleProps } from './types';

function TooltipTitle(props: TooltipTitleProps) {
  const { primary, secondary } = props;
  return (
    <Box className="flex flex-col">
      <Typography className="text-gray-300" variant="body-short-03">
        {primary}
      </Typography>
      {secondary ? (
        <Typography className="text-gray-300" variant="body-short-03">
          {secondary}
        </Typography>
      ) : null}
    </Box>
  );
}

export default TooltipTitle;
